module.exports = __webpack_public_path__ + "img/bbb.afda0800.png";